import request from '@/utils/request'

// 软件管理list
export function thirdpartyList(data) {
  return request({
    url: 'api/v2/thirdparty/thirdpartyList',
    method: 'post',
    data
  })
}

// 新增
export function thirdpartyAdd(data) {
  return request({
    url: 'api/v2/thirdparty/thirdpartyAdd',
    method: 'post',
    data
  })
}

//删除
export function thirdpartyDel(data) {
  return request({
    url: 'api/v2/thirdparty/thirdpartyDel',
    method: 'post',
    data
  })
}